export const isStandalonePwa = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;

const removeClaimTokenFromUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('pwaClaim');
  url.searchParams.delete('deviceClaim');
  const nextUrl = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState({}, '', nextUrl);
};

export const claimPwaDeviceJwtFromUrl = async ({ removeFromUrl = isStandalonePwa() } = {}) => {
  const params = new URLSearchParams(window.location.search);
  const claimToken = params.get('pwaClaim') || params.get('deviceClaim');
  if (!claimToken) return null;

  const response = await fetch('/api/devices/pwa-claim', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token: claimToken }),
  });

  if (!response.ok) {
    throw new Error(`PWA device claim failed (${response.status})`);
  }

  const data = await response.json();
  if (!data?.jwt) {
    throw new Error('PWA device claim response did not include a device token.');
  }

  localStorage.setItem('deviceJWT', data.jwt);
  if (removeFromUrl) {
    removeClaimTokenFromUrl();
  }

  return {
    deviceJwt: data.jwt,
    targetRoute: data.targetRoute || null,
  };
};
